<template>
  <div class="input-block" :class="{[formParam]:true,}">
    <form-select
      :name="'from_pref'"
      v-model="from_pref"
      label="出生地"
      :default-no-select="true"
      :options="FORM_OPTIONS.from_pref"
    />
  </div>
</template>

<script>
import { FORM_OPTIONS } from '@/CONSTS'
export default {
  name: 'InputBlockFromPref',
  data(){
    return {
      FORM_OPTIONS,
      from_pref: '',
      buttonIsDisabled: false,
    }
  },
  props: {
    formParam: {
      type: String,
      default: '',
    }
  },
  computed: {
    validateFlags () {
      return this.$validator.flags
    },
  },
  watch:{
    validateFlags: {
      handler(n) {
        this.buttonIsDisabled = Object.keys(n).some((key)=> n[key].invalid)
        this.$emit('on-input', {
          key: this.formParam,
          disable: !this.from_pref,
          inputData: {
            from_pref: this.from_pref
          }
        })
      },
      deep: true
    },
  },
}</script>

<style scoped lang="scss">
.input-block {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/inputParts/InputBlockFromPref.vue